import { Deserializable } from '../interfaces';

export class CreditCard implements Deserializable {
  cardId: Number | null;
  cardNumber: string;
  expiryDate: string;
  cvv: string;
  cardHolderName: string;
  default: boolean;
  email: string;
  phone: string;
  country: string;
  zipCode: string;
  state: string;
  city: string;
  address: string;
  shortDescription: string;

  constructor() {
    this.cardId = null;
    this.cardNumber = '';
    this.expiryDate = '';
    this.cvv = '';
    this.cardHolderName = '';
    this.default = false;
    this.country = '';
    this.zipCode = '';
    this.state = '';
    this.city = '';
    this.address = '';
    this.email = '';
    this.phone = '';
    this.shortDescription = '';
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
